import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { GiPodium } from "react-icons/gi";
import {
  IoChatbubbleEllipsesOutline,
  IoChevronDown,
  IoEyeOutline,
  IoBrushOutline,
  IoLanguage,
  IoPlay,
} from "react-icons/io5";
import {
  DIRECT_MESSAGE_PANEL_OPEN_EVENT,
  DIRECT_MESSAGE_UNREAD_EVENT,
  DIRECT_MESSAGE_UNREAD_GLOBAL_KEY,
} from "../../services/directMessageUi";
import {
  isGuestMustRegisterError,
  openGuestChampionshipRegister,
} from "../championship/guestChampionshipPrompt";
import ModernSidebar from "./ModernSidebar";
import "./lobbyModern.css";

// Tercer diseño del lobby («Moderno»): menú lateral, tarjetas de modo, botón JUGAR,
// partido destacado, partidas esperando rival, mejores jugadores y botón Campeonato.

const COPY = {
  es: {
    greeting: (name) => `Hola, ${name}`,
    title: "Jugar",
    tutorialTitle: "¿Primera vez? Aprende a jugar en 3 minutos",
    tutorialText: "Tutorial guiado paso a paso. Después te sugerimos el modo ideal.",
    tutorialButton: "Empezar tutorial",
    play: "JUGAR",
    playHint: (mode) => `${mode} · rival de tu nivel`,
    featured: "Partido destacado",
    seeAll: "Ver todos ›",
    seeAllF: "Ver todas ›",
    live: "EN VIVO",
    replay: "REPETICIÓN",
    turn: (n) => `Turno ${n}`,
    noLive: "No hay partidos en vivo ahora mismo",
    noLiveHint: "Cuando alguien juegue, lo verás aquí.",
    waiting: "Partidas esperando rival",
    player: "JUGADOR",
    place: "LUGAR",
    seats: "JUGADORES",
    time: "TIEMPO",
    minutes: (n) => `${n} min`,
    placeChampionship: "Campeonato XIMA",
    placeIndependent: (n) => `Partida independiente${n ? ` #${n}` : ""}`,
    placeTournament: (n) => `Torneo${n ? ` #${n}` : ""}`,
    placePaid: "con saldo",
    placeFree: "sin saldo",
    statusPlaying: "Jugando",
    watch: "VER",
    private: "PRIVADA",
    champOpen: "Inscripción abierta",
    playingNow: "jugando",
    champRunning: "En curso",
    champJoin: "UNIRME",
    champJoined: "INSCRITO",
    champFull: "LLENO",
    champJoinedOk: "¡Te uniste al campeonato!",
    editWaiting: "Editar partidas en espera",
    editWaitingOn: "Terminar edición",
    deleteMatch: "ELIMINAR",
    deleteConfirm: (place) => `¿Eliminar «${place}»? Los jugadores que esperan saldrán de ella.`,
    deleteError: "No se pudo eliminar la partida.",
    mode: "MODO",
    join: "UNIRSE",
    joining: "...",
    mine: "TU PARTIDA",
    noWaiting: "No hay partidas esperando rival. ¡Crea una!",
    createGame: "Crear juego",
    topPlayers: "Mejores jugadores",
    seeAllTop: "Ver todo ›",
    noRanking: "Sin datos todavía",
    championship: "CAMPEONATO",
    championshipHint: "Pirámide, horarios y partidas en vivo",
    menuPlay: "Jugar",
    menuLearn: "Aprender",
    menuTournaments: "Torneos",
    menuChampionship: "Campeonato",
    menuWatch: "Ver partidos",
    menuFriends: "Amigos",
    menuMine: "MI XIMA",
    menuStats: "Estadísticas",
    menuHistory: "Historial",
    menuDesign: "Diseñar tablero",
    menuStore: "Tienda",
    menuPremium: "Premium",
    menuSettings: "Ajustes",
    menuSupport: "Soporte",
    menuAdmin: "Admin",
    menuLogout: "Cerrar sesión",
    quickBot: "Contra el bot",
    quickFriends: "Con amigos",
    quickCreate: "Crear juego",
    quickFind: "Buscar partida",
    quickPuzzles: "Puzzles",
    quickSandbox: "Caja de arena",
    modeScience: "Ciencia",
    modeCienzar: "Cienzar",
    modeContrazar: "Contrazar",
    modeChance: "Azar",
    subScience: "Ideal para empezar",
    subCienzar: "Nivel intermedio",
    subContrazar: "Nivel avanzado",
    subChance: "Partida corta",
    designMode: "Modo Diseñar",
    messages: "Mensajes",
    language: "Idioma",
  },
  en: {
    greeting: (name) => `Hi, ${name}`,
    title: "Play",
    tutorialTitle: "First time? Learn to play in 3 minutes",
    tutorialText: "Step-by-step guided tutorial. Then we suggest the ideal mode for you.",
    tutorialButton: "Start tutorial",
    play: "PLAY",
    playHint: (mode) => `${mode} · rival at your level`,
    featured: "Featured match",
    seeAll: "See all ›",
    seeAllF: "See all ›",
    live: "LIVE",
    replay: "REPLAY",
    turn: (n) => `Turn ${n}`,
    noLive: "No live matches right now",
    noLiveHint: "When someone plays, you will see it here.",
    waiting: "Matches waiting for a rival",
    player: "PLAYER",
    place: "PLACE",
    seats: "PLAYERS",
    time: "TIME",
    minutes: (n) => `${n} min`,
    placeChampionship: "XIMA Championship",
    placeIndependent: (n) => `Independent match${n ? ` #${n}` : ""}`,
    placeTournament: (n) => `Tournament${n ? ` #${n}` : ""}`,
    placePaid: "paid",
    placeFree: "free",
    statusPlaying: "Playing",
    watch: "WATCH",
    private: "PRIVATE",
    champOpen: "Registration open",
    playingNow: "playing",
    champRunning: "In progress",
    champJoin: "JOIN",
    champJoined: "JOINED",
    champFull: "FULL",
    champJoinedOk: "You joined the championship!",
    editWaiting: "Edit waiting matches",
    editWaitingOn: "Done editing",
    deleteMatch: "DELETE",
    deleteConfirm: (place) => `Delete "${place}"? Players waiting in it will be removed.`,
    deleteError: "Could not delete the match.",
    mode: "MODE",
    join: "JOIN",
    joining: "...",
    mine: "YOUR GAME",
    noWaiting: "No matches waiting for a rival. Create one!",
    createGame: "Create game",
    topPlayers: "Top players",
    seeAllTop: "See all ›",
    noRanking: "No data yet",
    championship: "CHAMPIONSHIP",
    championshipHint: "Bracket, schedule and live games",
    menuPlay: "Play",
    menuLearn: "Learn",
    menuTournaments: "Tournaments",
    menuChampionship: "Championship",
    menuWatch: "Watch games",
    menuFriends: "Friends",
    menuMine: "MY XIMA",
    menuStats: "Statistics",
    menuHistory: "History",
    menuDesign: "Design board",
    menuStore: "Store",
    menuPremium: "Premium",
    menuSettings: "Settings",
    menuSupport: "Support",
    menuAdmin: "Admin",
    menuLogout: "Log out",
    quickBot: "Vs bot",
    quickFriends: "With friends",
    quickCreate: "Create game",
    quickFind: "Find match",
    quickPuzzles: "Puzzles",
    quickSandbox: "Sandbox",
    modeScience: "Science",
    modeCienzar: "Cienzar",
    modeContrazar: "Contrazar",
    modeChance: "Chance",
    subScience: "Best to start",
    subCienzar: "Intermediate",
    subContrazar: "Advanced",
    subChance: "Short game",
    designMode: "Design mode",
    messages: "Messages",
    language: "Language",
  },
};

export const MODES = [
  { id: "12", key: "ciencia", tone: "science", titleKey: "modeScience", subKey: "subScience", icon: "/mode-icons/free.png", liveMode: "free" },
  { id: "14", key: "cienzar", tone: "cienzar", titleKey: "modeCienzar", subKey: "subCienzar", icon: "/mode-icons/cienzar.png", liveMode: "cienzar" },
  { id: "15", key: "sciencevsazar", tone: "contrazar", titleKey: "modeContrazar", subKey: "subContrazar", icon: "/mode-icons/logo-contrazar.png", liveMode: "sciencevsazar" },
  { id: "13", key: "azar", tone: "chance", titleKey: "modeChance", subKey: "subChance", icon: "/mode-icons/logo-modo-azar.png", liveMode: "dice" },
];
export const MODE_BY_LIVE = Object.fromEntries(MODES.map((mode) => [mode.liveMode, mode]));
export const MODE_BY_CHAMPIONSHIP = { ciencia: MODES[0], cienzar: MODES[1], contrazar: MODES[2], azar: MODES[3] };
export const SELECTED_MODE_KEY = "xima_lobby_modern_mode_v1";
const ONLINE_MODES = new Set(["free", "dice", "cienzar", "sciencevsazar"]);

export const normalizeMode = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === "ciencia" || raw === "science") return "free";
  if (raw === "azar" || raw === "luck") return "dice";
  if (raw === "contrazar") return "sciencevsazar";
  return raw;
};

export const readSelectedMode = () => {
  try {
    const stored = window.localStorage.getItem(SELECTED_MODE_KEY);
    return MODES.some((mode) => mode.id === stored) ? stored : "12";
  } catch {
    return "12";
  }
};

const initialsOf = (name) =>
  String(name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "?";

const playerKey = (value) => String(value || "").trim().toLowerCase();

// Partidas independientes abiertas, sin contraseña ni pago; las mías van primero y marcadas.
export const pickWaitingMatches = (tournaments, myIds, nowMs = Date.now()) =>
  (Array.isArray(tournaments) ? tournaments : [])
    .filter((entry) => entry && entry.isIndependentMatch && !entry.isPuzzle)
    .filter((entry) => !entry.hasMatchPassword && !entry.championshipMatchId)
    .filter((entry) => !(Number(entry.tournamentRewardValue) > 0))
    .filter((entry) => ONLINE_MODES.has(normalizeMode(entry.mode)))
    .filter((entry) => {
      const startMs = new Date(entry.startingTime || 0).valueOf();
      const endMs = startMs + Number(entry.duration || 0) * 24 * 3600 * 1000;
      return !(Number.isFinite(endMs) && endMs > 0 && endMs < nowMs && Number(entry.duration) > 0);
    })
    .map((entry) => {
      const users = Array.isArray(entry.users) ? entry.users : [];
      const memberSize = Math.max(2, Number(entry.memberSize) || 2);
      const creatorId = playerKey(entry.createdBy);
      const creator =
        users.find((user) => playerKey(user?.userId) === creatorId) || users[0] || null;
      return { entry, users, memberSize, creator };
    })
    .filter(({ users, memberSize }) => users.length > 0 && users.length < memberSize)
    .map((item) => ({
      ...item,
      isMine: item.users.some((user) => myIds.has(playerKey(user?.userId))),
    }))
    .sort(
      (a, b) =>
        Number(b.isMine) - Number(a.isMine) ||
        new Date(b.entry.createdAt || 0).valueOf() - new Date(a.entry.createdAt || 0).valueOf()
    );

// Salas en línea del servidor: primero las que esperan rival (la mía arriba), luego las que juegan.
export const buildActivityRows = (activity, myIds) =>
  (Array.isArray(activity) ? activity : [])
    .filter((room) => room && Array.isArray(room.players) && room.players.length > 0)
    .map((room) => {
      const isMine = room.players.some((player) => myIds.has(playerKey(player?.userId)));
      const isWaiting = room.status === "waiting";
      const isPrivate = Boolean(room.hasPassword) || room.place?.kind === "championship";
      return {
        ...room,
        isMine,
        isWaiting,
        canJoin: isWaiting && !isMine && !isPrivate && room.seatsTaken < room.memberSize,
        isPrivate,
      };
    })
    .sort(
      (a, b) =>
        Number(b.isWaiting) - Number(a.isWaiting) ||
        Number(b.isMine) - Number(a.isMine)
    );

const LobbyModern = ({
  language,
  userName,
  userAvatar,
  userIds,
  rankLabel,
  cimaxTotalLabel,
  isAdmin,
  isOwner,
  socialPending,
  badges = {},
  designChooser,
  newsTicker,
  rankingSections,
  rankingLoading,
  onTutorial,
  onPlayMode,
  onJoinMatch,
  onOpenPlayerProfile,
  onOpenProfile,
  onNavigate,
  actions,
}) => {
  const copy = COPY[language] || (language === "es" ? COPY.es : COPY.en);
  const [selectedModeId, setSelectedModeId] = useState(readSelectedMode);
  const [liveMatches, setLiveMatches] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [activity, setActivity] = useState([]);
  const [championship, setChampionship] = useState(null);
  const [joiningChampionship, setJoiningChampionship] = useState(false);
  const [editingWaiting, setEditingWaiting] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [joiningId, setJoiningId] = useState("");
  const [playing, setPlaying] = useState(false);
  const [rankingTab, setRankingTab] = useState("ciencia");
  const [unreadMessages, setUnreadMessages] = useState(0);

  const selectMode = (id) => {
    setSelectedModeId(id);
    try {
      window.localStorage.setItem(SELECTED_MODE_KEY, id);
    } catch {
      // Without storage the choice only lasts while the page is open.
    }
  };

  useEffect(() => {
    let canceled = false;
    const load = () => {
      axios
        .get("/tournaments/live")
        .then((response) => {
          if (!canceled) setLiveMatches(Array.isArray(response?.data) ? response.data : []);
        })
        .catch(() => {});
      axios
        .get("/tournaments")
        .then((response) => {
          if (!canceled) setTournaments(Array.isArray(response?.data) ? response.data : []);
        })
        .catch(() => {});
      axios
        .get("/championship")
        .then((response) => {
          if (!canceled) setChampionship(response?.data || null);
        })
        .catch(() => {});
      axios
        .get("/tournaments/lobby-activity")
        .then((response) => {
          if (!canceled) setActivity(Array.isArray(response?.data) ? response.data : []);
        })
        .catch(() => {});
    };
    load();
    const intervalId = window.setInterval(load, 5000);
    return () => {
      canceled = true;
      window.clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const handleUnread = (event) =>
      setUnreadMessages(Math.max(0, Number(event?.detail?.total) || 0));
    window.addEventListener(DIRECT_MESSAGE_UNREAD_EVENT, handleUnread);
    setUnreadMessages(Math.max(0, Number(window[DIRECT_MESSAGE_UNREAD_GLOBAL_KEY]?.total) || 0));
    return () => window.removeEventListener(DIRECT_MESSAGE_UNREAD_EVENT, handleUnread);
  }, []);

  const live = useMemo(
    () => liveMatches.filter((match) => String(match?.type || "live") !== "historical"),
    [liveMatches]
  );
  const featured = useMemo(() => {
    if (live.length > 0) {
      return [...live].sort(
        (a, b) => (Number(b.spectators) || 0) - (Number(a.spectators) || 0)
      )[0];
    }
    return liveMatches.find((match) => match?.type === "historical" && match?.hasReplay !== false) || null;
  }, [live, liveMatches]);
  const featuredIsLive = Boolean(featured && featured.type !== "historical");
  const featuredPlayers = (Array.isArray(featured?.players) ? featured.players : [])
    .map((player) => player?.displayName || player?.name || player?.userId || "")
    .filter(Boolean);
  const featuredMode = MODE_BY_LIVE[normalizeMode(featured?.mode)];

  const myIds = useMemo(() => new Set((userIds || []).map(playerKey)), [userIds]);
  const activityRows = useMemo(() => buildActivityRows(activity, myIds), [activity, myIds]);
  // JUGAR first fills a public room of the chosen mode, then an open match without a room yet.
  const joinable = useMemo(
    () => [
      ...activityRows
        .filter((row) => row.canJoin && !row.place?.paid)
        .map((row) => ({
          entry: {
            _id: row.tournamentId,
            mode: row.mode,
            tournamentSequenceNumber: row.place?.number || 0,
          },
        })),
      ...pickWaitingMatches(tournaments, myIds).filter((item) => !item.isMine),
    ],
    [activityRows, myIds, tournaments]
  );

  const selectedMode = MODES.find((mode) => mode.id === selectedModeId) || MODES[0];
  const activeRanking =
    (rankingSections || []).find((section) => section.key === rankingTab) ||
    (rankingSections || [])[0];

  const handlePlay = useCallback(async () => {
    if (playing) return;
    setPlaying(true);
    try {
      await onPlayMode(selectedMode.liveMode, joinable);
    } finally {
      setPlaying(false);
    }
  }, [onPlayMode, playing, selectedMode.liveMode, joinable]);

  // Solo el dueño: elimina una partida o torneo desde la lista.
  const deleteRoom = async (row) => {
    if (!window.confirm(copy.deleteConfirm(placeLabel(row.place)))) return;
    setDeletingId(row.tournamentId);
    try {
      await axios.post("/tournaments/owner/tournaments/delete", { tournamentId: row.tournamentId });
      setActivity((current) => current.filter((item) => item.tournamentId !== row.tournamentId));
    } catch (error) {
      window.alert(error?.response?.data?.message || copy.deleteError);
    } finally {
      setDeletingId("");
    }
  };

  // Campeonato abierto o en curso: va arriba de la lista, como una partida más.
  const championshipRow =
    championship && ["registration", "running"].includes(championship.status) ? championship : null;
  const joinChampionship = async () => {
    if (!championshipRow || joiningChampionship) return;
    // Con contraseña o ya inscrito: se entra a la pantalla del Campeonato.
    if (championshipRow.joined || championshipRow.hasJoinPassword || championshipRow.status !== "registration") {
      actions.championship();
      return;
    }
    setJoiningChampionship(true);
    try {
      const response = await axios.post("/championship/join");
      setChampionship(response?.data || championshipRow);
      window.alert(copy.champJoinedOk);
    } catch (error) {
      if (isGuestMustRegisterError(error)) openGuestChampionshipRegister(onNavigate);
      else window.alert(error?.response?.data?.message || copy.deleteError);
    } finally {
      setJoiningChampionship(false);
    }
  };

  const placeLabel = (place) => {
    if (place?.kind === "championship") return copy.placeChampionship;
    if (place?.kind === "independent") return copy.placeIndependent(place.number);
    return `${copy.placeTournament(place?.number)} · ${place?.paid ? copy.placePaid : copy.placeFree}`;
  };

  const handleJoin = async (entry) => {
    const id = String(entry?._id || "");
    if (!id || joiningId) return;
    setJoiningId(id);
    try {
      await onJoinMatch(entry);
    } finally {
      setJoiningId("");
    }
  };

  const openFeatured = () => {
    if (!featured) return actions.watch();
    if (featuredIsLive) {
      return onNavigate(
        `/game/${featured.tournamentId}?autoplay=1&spectator=1&roomId=${encodeURIComponent(
          featured.roomId
        )}`
      );
    }
    return actions.watch();
  };

  const quick = [
    { id: "bot", icon: "🤖", label: copy.quickBot, onClick: actions.bot },
    { id: "friends", icon: "👫", label: copy.quickFriends, onClick: actions.localFriends },
    { id: "create", icon: "➕", label: copy.quickCreate, onClick: actions.create },
    { id: "find", icon: "🔍", label: copy.quickFind, onClick: actions.find },
    { id: "puzzles", icon: "🧩", label: copy.quickPuzzles, onClick: actions.puzzles },
    { id: "sandbox", icon: "🏖️", label: copy.quickSandbox, onClick: actions.sandbox },
  ];

  return (
    <div className="xlm-root">
      <ModernSidebar
        language={language}
        active="play"
        isAdmin={isAdmin}
        actions={actions}
        badges={{ ...badges, watch: badges.watch ?? live.length, friends: badges.friends ?? socialPending }}
      />

      <div className="xlm-main">
        <header className="xlm-topbar">
          <div className="xlm-heading">
            <span>{copy.greeting(userName)}</span>
            <h1>{copy.title}</h1>
          </div>
          <div className="xlm-design-slot">{designChooser}</div>
          <div className="xlm-top-actions">
            <button type="button" className="xlm-round" onClick={actions.design} aria-label={copy.designMode} title={copy.designMode}>
              <IoBrushOutline />
            </button>
            <button type="button" className="xlm-round" onClick={() => window.dispatchEvent(new CustomEvent(DIRECT_MESSAGE_PANEL_OPEN_EVENT))} aria-label={copy.messages}>
              <IoChatbubbleEllipsesOutline />
              {unreadMessages > 0 ? <b>{Math.min(99, unreadMessages)}</b> : null}
            </button>
            <button type="button" className="xlm-round" onClick={actions.language} aria-label={copy.language} title={copy.language}>
              <IoLanguage />
            </button>
            <button type="button" className="xlm-profile" onClick={onOpenProfile}>
              <span className="xlm-profile-avatar">
                {userAvatar ? <img src={userAvatar} alt="" /> : initialsOf(userName)}
              </span>
              <strong>{userName}</strong>
              <em>
                {rankLabel} · {cimaxTotalLabel}
              </em>
              <IoChevronDown aria-hidden="true" />
            </button>
          </div>
        </header>

        {newsTicker ? <div className="xlm-ticker">{newsTicker}</div> : null}

        <section className="xlm-tutorial">
          <span className="xlm-tutorial-icon" aria-hidden="true">🎓</span>
          <div>
            <strong>{copy.tutorialTitle}</strong>
            <span>{copy.tutorialText}</span>
          </div>
          <button type="button" onClick={onTutorial}>
            {copy.tutorialButton}
          </button>
        </section>

        <div className="xlm-grid">
          <div className="xlm-col-main">
            <div className="xlm-modes">
              {MODES.map((mode) => (
                <button
                  key={mode.id}
                  type="button"
                  className={`xlm-mode is-${mode.tone}${mode.id === selectedModeId ? " is-selected" : ""}`}
                  onClick={() => selectMode(mode.id)}
                  aria-pressed={mode.id === selectedModeId}
                >
                  <span className="xlm-mode-icon">
                    <img src={mode.icon} alt="" />
                  </span>
                  {mode.id === selectedModeId ? <span className="xlm-mode-check">✔</span> : null}
                  <strong>{copy[mode.titleKey]}</strong>
                  <span className="xlm-mode-playing">
                    👥 {Number(badges.playingByMode?.[mode.liveMode]) || 0} {copy.playingNow}
                  </span>
                  <small>
                    {mode.id === "12" ? "⭐ " : ""}
                    {copy[mode.subKey]}
                  </small>
                </button>
              ))}
            </div>

            <div className="xlm-quick">
              {quick.map((item) => (
                <button key={item.id} type="button" onClick={item.onClick}>
                  <span aria-hidden="true">{item.icon}</span>
                  <strong>{item.label}</strong>
                </button>
              ))}
            </div>

            <button type="button" className="xlm-play" onClick={handlePlay} disabled={playing}>
              <span className="xlm-play-main">
                <IoPlay aria-hidden="true" /> {copy.play}
              </span>
              <span className="xlm-play-hint">{copy.playHint(copy[selectedMode.titleKey])}</span>
            </button>
          </div>

          <section className="xlm-card xlm-featured">
            <div className="xlm-card-head">
              <span>📺 {copy.featured}</span>
              <button type="button" onClick={actions.watch}>
                {copy.seeAll}
              </button>
            </div>
            <button type="button" className="xlm-featured-media" onClick={openFeatured}>
              <img src="/lobby-modern/destacado.jpg" alt="" />
              {featured ? (
                <>
                  <span className={`xlm-live-pill${featuredIsLive ? "" : " is-replay"}`}>
                    {featuredIsLive ? <i /> : "▶ "}
                    {featuredIsLive ? copy.live : copy.replay}
                  </span>
                  {featuredIsLive ? (
                    <span className="xlm-viewers">
                      <IoEyeOutline aria-hidden="true" /> {Number(featured.spectators) || 0}
                    </span>
                  ) : null}
                  <span className="xlm-featured-foot">
                    <strong>{featuredPlayers.join(" vs ") || featured.tournamentName || ""}</strong>
                    <span>
                      {featuredMode ? copy[featuredMode.titleKey] : ""}
                      {featured.tournamentSequenceNumber ? ` · #${featured.tournamentSequenceNumber}` : ""}
                    </span>
                  </span>
                </>
              ) : (
                <span className="xlm-featured-empty">
                  <strong>{copy.noLive}</strong>
                  <span>{copy.noLiveHint}</span>
                </span>
              )}
            </button>
          </section>

          <section className="xlm-card xlm-waiting">
            <div className="xlm-card-head">
              <span>🔍 {copy.waiting}</span>
              <span className="xlm-card-head-actions">
                {isOwner ? (
                  <button
                    type="button"
                    className={`xlm-owner-edit${editingWaiting ? " is-active" : ""}`}
                    onClick={() => setEditingWaiting((current) => !current)}
                  >
                    {editingWaiting ? copy.editWaitingOn : copy.editWaiting}
                  </button>
                ) : null}
                <button type="button" onClick={actions.find}>
                  {copy.seeAllF}
                </button>
              </span>
            </div>
            <div className="xlm-table">
              <div className="xlm-table-row is-head">
                <span>{copy.player}</span>
                <span>{copy.place}</span>
                <span>{copy.mode}</span>
                <span>{copy.seats}</span>
                <span>{copy.time}</span>
                <span />
              </div>
              {championshipRow
                ? (() => {
                    const mode = MODE_BY_CHAMPIONSHIP[championshipRow.gameMode] || MODES[0];
                    const seats = `${(championshipRow.players || []).length}/${championshipRow.maxPlayers || 0}`;
                    const isOpen = championshipRow.status === "registration";
                    const isFull = (championshipRow.players || []).length >= (championshipRow.maxPlayers || 0);
                    return (
                      <div
                        className="xlm-table-row is-championship"
                        data-meta={`${copy[mode.titleKey]} · ${seats} · ${copy.minutes(championshipRow.timeMinutes || 5)}`}
                      >
                        <span className="xlm-table-name" title={championshipRow.title}>
                          🏆 {championshipRow.title || "Campeonato XIMA"}
                          <small>{isOpen ? copy.champOpen : copy.champRunning}</small>
                        </span>
                        <span className="xlm-table-place">
                          {copy.placeChampionship}
                          {championshipRow.prize ? ` · ${championshipRow.prize}` : ""}
                        </span>
                        <span className="xlm-table-mode">
                          <i className={`is-${mode.tone}`} />
                          {copy[mode.titleKey]}
                        </span>
                        <span>{seats}</span>
                        <span>{copy.minutes(championshipRow.timeMinutes || 5)}</span>
                        <span>
                          <button
                            type="button"
                            className={`xlm-join ${isOpen && !championshipRow.joined && !isFull ? "is-championship" : "is-watch"}`}
                            disabled={joiningChampionship}
                            onClick={joinChampionship}
                          >
                            {!isOpen
                              ? copy.watch
                              : championshipRow.joined
                              ? copy.champJoined
                              : isFull
                              ? copy.champFull
                              : joiningChampionship
                              ? "..."
                              : `${championshipRow.hasJoinPassword ? "🔒 " : ""}${copy.champJoin}`}
                          </button>
                        </span>
                      </div>
                    );
                  })()
                : null}
              {activityRows.length ? (
                activityRows.map((row) => {
                  const mode = MODE_BY_LIVE[normalizeMode(row.mode)];
                  const key = `${row.tournamentId}-${row.roomId}`;
                  const names = row.players.map((player) => player.displayName).join(" vs ");
                  return (
                    <div
                      key={key}
                      className={`xlm-table-row${row.isMine ? " is-mine" : ""}${row.isWaiting ? "" : " is-playing"}`}
                      data-meta={`${mode ? copy[mode.titleKey] : row.mode} · ${row.seatsTaken}/${row.memberSize} · ${copy.minutes(row.havingTime)}`}
                    >
                      <span className="xlm-table-name" title={names}>
                        {names}
                        {row.isWaiting ? null : <small>{copy.statusPlaying}</small>}
                      </span>
                      <span className="xlm-table-place" title={row.place?.name || ""}>
                        {placeLabel(row.place)}
                      </span>
                      <span className="xlm-table-mode">
                        <i className={`is-${mode?.tone || "science"}`} />
                        {mode ? copy[mode.titleKey] : row.mode}
                      </span>
                      <span>
                        {row.seatsTaken}/{row.memberSize}
                      </span>
                      <span>{copy.minutes(row.havingTime)}</span>
                      <span>
                        {isOwner && editingWaiting ? (
                          <button
                            type="button"
                            className="xlm-join is-delete"
                            disabled={deletingId === row.tournamentId}
                            onClick={() => deleteRoom(row)}
                          >
                            {deletingId === row.tournamentId ? "..." : copy.deleteMatch}
                          </button>
                        ) : row.isMine && row.isWaiting ? (
                          <span className="xlm-mine">{copy.mine}</span>
                        ) : !row.isWaiting ? (
                          <button
                            type="button"
                            className="xlm-join is-watch"
                            onClick={() =>
                              onNavigate(
                                `/game/${row.tournamentId}?autoplay=1&spectator=1&roomId=${encodeURIComponent(
                                  row.roomId
                                )}`
                              )
                            }
                          >
                            {copy.watch}
                          </button>
                        ) : row.canJoin ? (
                          <button
                            type="button"
                            className="xlm-join"
                            onClick={() =>
                              handleJoin({
                                _id: row.tournamentId,
                                mode: row.mode,
                                tournamentSequenceNumber: row.place?.number || 0,
                              })
                            }
                            disabled={Boolean(joiningId)}
                          >
                            {joiningId === row.tournamentId ? copy.joining : copy.join}
                          </button>
                        ) : (
                          <span className="xlm-mine is-private">{copy.private}</span>
                        )}
                      </span>
                    </div>
                  );
                })
              ) : championshipRow ? null : (
                <div className="xlm-table-empty">
                  <span>{copy.noWaiting}</span>
                  <button type="button" onClick={actions.create}>
                    {copy.createGame}
                  </button>
                </div>
              )}
            </div>
          </section>

          <div className="xlm-col-side">
            <button type="button" className="xlm-championship" onClick={actions.championship}>
              <GiPodium aria-hidden="true" />
              <span>
                <strong>{copy.championship}</strong>
                <small>{copy.championshipHint}</small>
              </span>
            </button>

            <section className="xlm-card xlm-top">
              <div className="xlm-card-head">
                <span>🏅 {copy.topPlayers}</span>
                <button type="button" onClick={actions.ranking}>
                  {copy.seeAllTop}
                </button>
              </div>
              <div className="xlm-tabs">
                {(rankingSections || []).map((section) => (
                  <button
                    key={section.key}
                    type="button"
                    className={section.key === activeRanking?.key ? "is-active" : ""}
                    onClick={() => setRankingTab(section.key)}
                  >
                    {section.label}
                  </button>
                ))}
              </div>
              <div className="xlm-top-list">
                {activeRanking?.players?.length ? (
                  activeRanking.players.map((player, index) => (
                    <button
                      key={`${activeRanking.key}-${player.name}-${index}`}
                      type="button"
                      className="xlm-top-row"
                      onClick={() => onOpenPlayerProfile(player.raw)}
                    >
                      <span aria-hidden="true">{["🥇", "🥈", "🥉"][index] || "🏅"}</span>
                      <strong>{player.name}</strong>
                      <em>{player.score}</em>
                    </button>
                  ))
                ) : (
                  <div className="xlm-top-empty">{rankingLoading ? "…" : copy.noRanking}</div>
                )}
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LobbyModern;
